import Banner from "@/components/ui/banner";
import { ERROR_TYPE_LABELS, RequestErrorType, RequestLogStatus } from "@/types/request-status";

interface RequestErrorBannerProps {
  status: RequestLogStatus;
  errorType: RequestErrorType | null;
  errorMessage: string | null;
  className?: string;
}

// Split error messages into separate lines for display
// Backend already handles deduplication and prefix removal, so we just format for display
const formatErrorMessage = (message: string): string[] => {
  // Split by newlines and filter empty lines
  const lines = message.split(/\n+/).filter(line => line.trim());
  return lines.length > 0 ? lines : [message.trim()];
};

export const RequestErrorBanner = ({
  status,
  errorType,
  errorMessage,
  className,
}: RequestErrorBannerProps) => {
  if (status === "SUCCESS") {
    return null;
  }

  const bannerType = status === "ERROR" ? "error" : "warning";
  const errorLabel =
    errorType && errorType in ERROR_TYPE_LABELS ? ERROR_TYPE_LABELS[errorType] : null;
  const title = errorLabel || status;
  const prefix = errorMessage ? `${title}:` : title;

  const errorLines = errorMessage ? formatErrorMessage(errorMessage) : [];
  const hasMultipleLines = errorLines.length > 1;

  return (
    <Banner type={bannerType} prefix={prefix} className={className}>
      {errorLines.length > 0 && (
        <span className="font-normal">
          {hasMultipleLines ? (
            <ul className="m-0 list-inside list-disc pl-0">
              {errorLines.map(line => (
                <li key={line}>{line.trim()}</li>
              ))}
            </ul>
          ) : (
            errorLines[0]
          )}
        </span>
      )}
    </Banner>
  );
};

export default RequestErrorBanner;
